import dayjs, { Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

/**
 * Converts a UTC date received from the backend to a local Date
 * (for display in calendar, form, etc.)
 */
export const toLocalDate = (date: string | Date | Dayjs | null | undefined): Date => {
    if (!date) return new Date()

    console.log('toLocalDate input:', date);
    if (dayjs.isDayjs(date)) {
        // якщо прийшов dayjs об'єкт — просто перевести у локальний
        console.log("Result:", date.utc(true).local().toDate());
        return date.utc(true).local().toDate()
    }

    // якщо це рядок без 'Z', усе одно вважаємо його UTC
    const str = typeof date === 'string' ? date : dayjs(date).format('YYYY-MM-DDTHH:mm:ss')

    // інтерпретуємо як UTC і переводимо у локальний
    console.log("Result:", dayjs.utc(str, 'YYYY-MM-DDTHH:mm:ss').local().toDate());
    return dayjs.utc(str, 'YYYY-MM-DDTHH:mm:ss').local().toDate()
}

/**
 * Converts the user's local time to a true UTC-0 Date
 * (to save or send to the backend)
 */
export const toUtcDate = (date: string | Date | Dayjs | null | undefined): Date => {
    if (!date) return new Date()
    const d = dayjs.isDayjs(date) ? date : dayjs(date)
    return d.subtract(d.utcOffset(), 'minute').utc().toDate()
}
